import React, { useState, useEffect, useCallback } from "react"
import { useTranslation } from "react-i18next"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { MyIcon, Badge, MyUI } from "src/core/components"
import { HEE } from "@macashipo/mlib"
import { HApi } from "src/core/helpers"
import { connect, ConnectedProps } from "react-redux"
import { updateNotificationCount } from "src/App/App.actions"
import { signalRTypes } from "src/App/App.constants"

import styled from "styled-components"

const mapStateToProps = state => ({
  count: state.app.notification_count,
})

const mapDispatchToProps = {
  updateCount: updateNotificationCount,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {}

const Notify = (props: Props) => {
  const { count, updateCount } = props
  const { t } = useTranslation()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const signalType = `ers_${signalRTypes.notifyCount}`
  const toggle = () => {
    // if (dropdownOpen === false) {
    //   updateCount(null)
    // }
    setDropdownOpen(prevState => !prevState)
  }
  const receiveSignalUpdate = useCallback(
    obj => {
      if (obj?.notifyCount) {
        updateCount(obj.notifyCount)
        if (obj?.needAnimation !== false) {
          const bell = document.getElementById("noti-bell")
          if (bell) {
            bell.classList.add("bell-ring")
            setTimeout(() => {
              bell.classList.remove("bell-ring")
            }, 2000)
          }
        }
      } else if (obj.notifyCount === 0) {
        updateCount(null)
      }
    },
    [updateCount]
  )
  useEffect(() => {
    HEE.on(signalType, receiveSignalUpdate)
    requestFirst()
    return () => {
      HEE.removeListener(signalType, receiveSignalUpdate, null, false)
    }
    // eslint-disable-next-line
  }, [receiveSignalUpdate, signalType])

  const requestFirst = () => {
    HApi.apiGeneric({
      method: "POST",
      url: "Notification/TotalNew",
      data: {},
    })
      .then(response => {
        if (response.Data?.Count) {
          updateCount(response.Data.Count)
        }
      })
      .catch(error => {})
  }
  return (
    <Wrap>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle
          outline
          color="link"
          className="p-0"
          style={{ height: "40px", width: "40px" }}
        >
          <MyIcon
            id="noti-bell"
            data="type:HiBell"
            size={24}
            style={{ color: "#7d7d7d" }}
          />
          <Badge
            color="danger"
            pill
            className="position-absolute translate-middle"
            style={{ top: "0.5rem", right: "-0.5rem" }}
          >
            {count > 9 ? `9+` : count}
          </Badge>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header style={{ fontSize: 15 }}>
            {t("dnt:notification.Title")}
          </DropdownItem>
          <DropdownItem divider />
          {dropdownOpen && <MyUI type="notification_list" />}
        </DropdownMenu>
      </Dropdown>
    </Wrap>
  )
}
const Wrap = styled.div`
  & .dropdown > button:focus {
    box-shadow: none;
  }
  & .dropdown-menu {
    right: 0;
    left: unset !important;
    width: 540px;
    border-radius: 0.25rem;
    box-shadow: 0 4px 8px -2px rgba(9, 30, 66, 0.25),
      0 0 1px rgba(9, 30, 66, 0.31);
  }
  & .notifications {
    max-height: calc(100vh - 200px);
    overflow: auto;
    overflow: overlay;
  }
  @media (max-width: 768px) {
    & .dropdown {
      position: unset;
      & > button {
        position: relative;
      }
    }
    & .dropdown-menu {
      width: calc(100vw - 32px);
      top: 1rem !important;
      right: 1rem !important;
    }
    & .notifications {
      max-height: calc(100vh - 144px);
    }
  }
`
export default connector(Notify)
